export const editFormAnimation = {
  initial: { opacity: 0, height: 0, x: -200 },
  animate: { opacity: 1, height: 'auto', x: 0 },
  exit: { opacity: 0, height: 0, x: -200 },
};
